import React, { useCallback, useState } from 'react';
import { useDropzone } from 'react-dropzone';
import { FiUpload, FiFile } from 'react-icons/fi';
import { Drop, FileError } from './styles.js';

const Dropzone = ({ onFileUploaded }) => {
  const [selectedFileName, setSelectedFileName] = useState('');

  const [fileError, setFileError] = useState('');

  const onDrop = useCallback(
    acceptedFiles => {
      const file = acceptedFiles[0];

      if (!file) {
        setFileError('Arquivo inválido!');
        return;
      }
      const fileName = file.name;
      setFileError('');
      setSelectedFileName(fileName);
      onFileUploaded(file);
    },
    [onFileUploaded]
  );

  const { getRootProps, getInputProps, isDragActive } = useDropzone({
    onDrop,
    accept: '.csv, application/vnd.ms-excel, text/csv',
  });

  return (
    <Drop {...getRootProps()}>
      <input
        accept=".csv, application/vnd.ms-excel, text/csv"
        {...getInputProps()}
      />

      {selectedFileName ? (
        <p>
          <FiFile size={54} />
          {selectedFileName}
        </p>
      ) : isDragActive ? (
        <p>
          <FiFile size={54} />
          Solte aqui seu arquivo csv!
        </p>
      ) : (
        <p>
          <FiUpload size={54} />
          Arraste aqui seu arquivo csv!
          <FileError>{fileError}</FileError>
        </p>
      )}
    </Drop>
  );
};

export default Dropzone;
